import { render, staticRenderFns } from "./Storehouses.vue?vue&type=template&id=28359bd6&scoped=true&"
import script from "./Storehouses.vue?vue&type=script&lang=js&"
export * from "./Storehouses.vue?vue&type=script&lang=js&"
import style0 from "./Storehouses.vue?vue&type=style&index=0&id=28359bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28359bd6",
  null
  
)

export default component.exports